import switchGroup from './switch-group';
import dragBlock from './drag-block';
import {focusBlock, getNodeInToolbox} from '../highlight';
import Audio from '../../lib/audio';
import {BATCH_TIPS_MODE, TRAIN_MODE} from '../../lib/constant';
import {blocksDesc} from '../blocks';

/**
 * 先切换到group，再dragBlock
 * 参数与dragBlock一致，参数说明直接参考dragBlock
 * @returns {Promise<unknown>|Promise<Promise>}
 */
export default function addBlock({tips, source, target}, mode, _index) {
    //代码中通过mode是否为undefined来判断是否要显示聊天记录，因此这里不能初始化 if (mode === undefined) mode = stepsRuntime.mode;
    if (_index === undefined) _index = {stepIndex: stepsRuntime.stepIndex, actionIndex: stepsRuntime.actionIndex};
        const g = getNodeInToolbox(source);
        if (mode) {
            if (!tips) {
                if (source.opcode && blocksDesc[source.opcode]) {
                    tips = '添加『 ' + blocksDesc[source.opcode].name + ' 』积木块到目标位置';
                }else if (g) {
                    tips = '添加『 ' + g.textContent + ' 』积木块到目标位置';
                }else {
                    tips = '拖动指定积木块到目标位置';
                }
            }
            window.stepsRuntime.insertTips(_index, tips);
        }


        if (!g) { //可能来自于自定义函数里的参数
            return dragBlock({tips, source, target});
        }
        /*
        let cat = g.getAttribute('data-category') || "myBlocks";
        if (source.opcode === "sensing_of") {
            cat = 'sensing';
        }*/
        let cat = source.opcode.substr(0, source.opcode.indexOf('_'));
        if (cat === 'operator' || cat === 'event') {
            cat += 's';
        }
        if (cat === 'data') cat = 'variables';
        if (cat === 'procedures') cat = 'myBlocks';
        if (mode === BATCH_TIPS_MODE) {
            return new Promise(resolve => {
                resolve();
            });
        }else if (mode === TRAIN_MODE) {
            return switchGroup({id: cat, noTips: true})
                .then(() => {
                    return focusBlock({source, target, tips}, mode, _index);
                });
        }else {
            return switchGroup({id: cat, noTips: true})
                .then(() => {
                    return dragBlock({source, target});
                });
        }
}
